import { Ng2StateDeclaration } from "@uirouter/angular";
import { Error503PageComponent } from "./error.503.component";

export const error503StateDeclaration: Ng2StateDeclaration = {
  name: 'error.503',
  url: "/503",
  component: Error503PageComponent
}
